import React from "react";

const features = [
  {
    title: "Premium Quality",
    description:
      "Each tool is made from industrial-grade materials to ensure long-lasting performance in professional insulation applications.",
    icon: (
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path d="M12 2l1.5 4.5H18l-3.75 2.7L15.5 14 12 10.5 8.5 14l1.25-4.8L6 6.5h4.5L12 2z" />
      </svg>
    ),
  },
  {
    title: "Eco Friendly",
    description:
      "Thermocol used is recyclable and designed to minimize material waste, offering an environmentally conscious solution.",
    icon: (
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path d="M5 13l4 4L19 7" />
      </svg>
    ),
  },
  {
    title: "24/7 Premium Support",
    description:
      "Our tools and support are accessible around the clock—anytime, anywhere you need them.",
    icon: (
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path d="M3 10h11M9 21V3m12 6h-4v6h4V9z" />
      </svg>
    ),
  },
];

const Services = () => {
  return (
    <div className="bg-white flax">
      <div className="section-container flex flex-col-reverse lg:flex-row gap-10 items-center">
        {/* Left side - Images */}
        <div className="relative w-full">
          <img
            src={`/assets/service1.webp`}
            alt="Products"
            className="md:w-[90%] shadow-sharp-blue"
          />
          <img
            src={`/assets/serv3.webp`}
            alt="Overlay Products"
            className="absolute bottom-0 right-[5rem] w-[50%] shadow-sharp-blue transform translate-x-1/4 translate-y-1/4 "
          />
        </div>

        {/* Right side - Content */}
        <div className="title-space text-text_color-100">
          <div className="section-title">Our Services</div>
          <div className="title-description">
            We take responsibility for your <br /> products like our own.
          </div>
          <div className="">
            At Thermocraft, we treat your packaging needs with the same care and
            precision as if they were our own. From design to delivery, we
            ensure top-notch quality, environmental responsibility, and
            round-the-clock support.
          </div>

          <div className="space-y-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="p-3 bg-blue-100 text-white rounded-full">
                  <span className="text-xl">{feature.icon}</span>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-text_color-200">{feature.title}</h4>
                  <p className="text-sm text-text_color-100">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
